import CloseIcon from '@mui/icons-material/Close';
import { DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import CustomInput from '../../../components/CustomInput';
import { ControlpanelPrimaryButton, ControlpanelSecondaryButton, GrayIconButton } from '../../../components/StyledButton';
import { CustomDialog } from '../../../components/StyledComponents';
import { useLoading } from '../../../context/LoadingContext';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { addDepartment } from '../../../axios/Department/DepartmentApi';
import CustomInputHorizontal from '../../../components/CustomInputHorizontal';
import DefaultTooltip from '../../../components/DefaultTooltip';
import QuestionIcon16pxSvg from '../../../assets/images/icons/QuestionIcon16pxSvg';
import MapSection from './MapSection';
import { addLocations, editLocations } from '../../../axios/Setting/SettingUrlApi';

const EditLocationDialog = (props) => {
   const { locationData, onClose, onRefresh } = props;
   const [show, hide] = useLoading();
   const { t } = useTranslation();

   const initialFormData = {
      name: '',
      address: '',
      latitude: '',
      longitude: '',
      radius: '',
      langId: localStorage.getItem("i18nextLngId")
   };


   const [formData, setFormData] = useState(initialFormData);

   useEffect(() => {
      if (locationData) {
         setFormData({
            id: locationData.id, // ✅ nhớ id để gửi BE
            name: locationData.locationName,
            address: locationData.address,
            latitude: locationData.latitude,
            longitude: locationData.longitude,
            radius: locationData.radius,
            langId: localStorage.getItem("i18nextLngId")
         });
      }
   }, [locationData]);

   const handleCloseDialog = () => {
      setFormData(initialFormData);
      onClose();
   };


   const updateFormDataAndValidate = (name, value) => {
      if (name === 'departmentPrefix') {
         // Giới hạn 2 ký tự + uppercase
         const trimmedValue = value.toUpperCase().slice(0, 2);

         setFormData((prevData) => ({
            ...prevData,
            [name]: trimmedValue,
         }));
      } else {
         setFormData((prevData) => ({
            ...prevData,
            [name]: value,
         }));
      }
   };

   const handleInputChange = (e) => {
      const { name, value } = e.target;
      updateFormDataAndValidate(name, value);
   };


   const handleSubmit = async (e) => {
      e.preventDefault();
      show();

      try {
         const payload = {
            ...formData,
            id: formData.id,
            latitude: Number(formData.latitude),
            longitude: Number(formData.longitude),
            radius: Number(formData.radius)
         };

         const response = await editLocations(payload);
         if (response.status === 200) {
            const code = response?.data?.data?.responseCode;
            if (code === undefined || code === 0) {
               handleCloseDialog();
               toast.success(t('common.edit-location-successfully'));
               onRefresh();
            } else {
               toast.error(response.data.data.message)
            }
         } else if (response.status === 500) {
            toast.error(response.data.message)
            handleCloseDialog();
         } else {
            toast.error(response.data.data.responseCode ? response.data.data.message : response.data.data.fieldErrors[0]?.message)
         }
      } catch (error) {
         if (error.response) {
            if (error.response.status !== 401) {
               toast.error(t(error?.response.data));
            }
         } else {
            toast.error(t('common.network-timeout'));
         }
      } finally {
         hide()
      }
   };

   return (
      <CustomDialog maxWidth={'md'} open onClose={handleCloseDialog} keepMounted>
         <DialogTitle>
            <div className='flex justify-between'>
               <div className='flex items-center gap-4'>
                  <p className='text-xl font-semibold '>{t('common.location')}</p>
               </div>
               <GrayIconButton onClick={handleCloseDialog}>
                  <CloseIcon />
               </GrayIconButton>
            </div>
         </DialogTitle>

         <DialogContent>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-4 mt-5'>

               {/* LEFT FORM */}
               <div className='space-y-2'>
                  <div>
                     <label>{t('common.name')}</label>
                     <CustomInput name='name' value={formData.name} handleInputChange={handleInputChange} />
                  </div>

                  <div>
                     <label>{t('common.address')}</label>
                     <CustomInput name='address' value={formData.address} handleInputChange={handleInputChange} />
                  </div>

                  <div>
                     <label>{t('common.latitude')}</label>
                     <CustomInput name='latitude' value={formData.latitude} handleInputChange={handleInputChange} />
                  </div>

                  <div>
                     <label>{t('common.longitude')}</label>
                     <CustomInput name='longitude' value={formData.longitude} handleInputChange={handleInputChange} />
                  </div>

                  <div>
                     <label>{t('common.radius')}</label>
                     <CustomInput name='radius' value={formData.radius} handleInputChange={handleInputChange} />
                  </div>
               </div>

               {/* RIGHT MAP */}
               <div className='h-[368px]'>
                  <MapSection formData={formData} setFormData={setFormData} />
               </div>

            </div>
         </DialogContent>

         <DialogActions>
            <div className='flex gap-2 px-4 py-4'>
               <ControlpanelSecondaryButton onClick={handleCloseDialog}>
                  <CloseIcon />
                  <p>{t('button.cancel')}</p>
               </ControlpanelSecondaryButton>

               <ControlpanelPrimaryButton
                  onClick={handleSubmit}
                  disabled={
                     !formData.name ||
                     !formData.address ||
                     !formData.latitude ||
                     !formData.longitude ||
                     !formData.radius
                  }
               >
                  <AddBoxIcon />
                  <p>{t('button.edit')}</p>
               </ControlpanelPrimaryButton>
            </div>
         </DialogActions>
      </CustomDialog>
   );
};

export default EditLocationDialog;
